    import { Card } from '@mui/material'
    import SoftButton from 'components/SoftButton'
    import Footer from 'examples/Footer'
    import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
    import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
    import React, { useEffect, useState } from 'react'
    import { useNavigate, useParams } from 'react-router-dom'
    import { api } from 'utils/Api'
    import DetailBox from 'utils/Detail-Box/DetailBox'
    import AdminProperties from './Property/AdminProperties'
    import AdminManagers from './Manager/AdminManagers'
    import AdminConcierge from './Concierge/AdminConcierge'
    import { getSecureItem } from 'utils/SecureStorage'
    import Swal from 'sweetalert2'
import { useAuth } from 'context/AuthContext'

    function AdminPropertiesDetail() {
        const [orgData, setOrgData] = useState({});
        const { propertyDetailTab } = useParams();
        const navigate = useNavigate();
        const orgId = JSON.parse(getSecureItem("currentUser"))?.organization_id;
        const {isAdmin, isManager, isStaff, isUser} = useAuth();

        const fetchProperties = async () => {
            try {
                const response = await api.organization.getFilteredOrgs(orgId);
                setOrgData(response);
            } catch (e) {
                
            }
        };

        useEffect(() => {
            fetchProperties();
        }, []);
        
        const activeTab = propertyDetailTab || "properties";

        // If URL is just /super-admin/organization → redirect to default tab
        // useEffect(() => {
        //     if (!propertyDetailTab) {
        //         if(isAdmin) {
        //                 navigate(`/admin/properties/${orgId}/${activeTab}`, { replace: true })
        //             }
        //         else if(isManager) {
        //             navigate(`/manager/properties/${orgId}/${activeTab}`, { replace: true })
        //         }
        //         else if(isStaff) {
        //             navigate(`/concierge/unit`, { replace: true })
        //         }
        //         else if(isUser) {
        //             navigate(`/user/unit`, { replace: true })
        //         }
        //     }
        // }, [propertyDetailTab, navigate, orgId]);

        useEffect(() => {
  if (!propertyDetailTab) {
    if (isAdmin) {
      navigate(`/admin/properties/${orgId}/${activeTab}`, { replace: true });
    } else if (isManager) {
      navigate(`/manager/properties/${orgId}/${activeTab}`, { replace: true });
    } else if (isStaff) {
      navigate(`/concierge/unit`, { replace: true });
    } else if (isUser) {
      navigate(`/user/properties`, { replace: true }); // ✅ UPDATED
    }
  }
}, [propertyDetailTab, navigate, orgId]);



        return (
            <DashboardLayout>
                <DashboardNavbar />
                <DetailBox
                    title={`${orgData?.name}` || "Organization Details"}
                    data={orgData}
                    inputs={[
                        // { label: "Organization Name", key: "name" },
                        { label: "Email Address", key: "email" },
                        { label: "Description", key: "description" },
                    ]} />
                <Card
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        mb: 1,
                        p: 1,
                        background: "#f5f7fa",
                        borderRadius: "10px",
                        width: "fit-content",
                    }}
                >
                    <SoftButton
                        onClick={() =>
                            navigate( isAdmin ? `/admin/properties` : isManager ? `/manager/properties` : isStaff ? `/concierge/unit` : isUser ? `/user/unit` : `/unauthorized`)}
                        size="small"
                        sx={{
                            px: 3,
                            borderRadius: "8px",
                            fontWeight: 600,
                            backgroundColor: activeTab === "properties" ? "#e3f2fd" : "#ffffff",
                            color: activeTab === "properties" ? "#03a9f4" : "#9e9e9e",
                            border: "2px solid",
                            borderColor: activeTab === "properties" ? "#b3e5fc" : "#e0e0e0",
                            borderBottom: "none",
                            borderBottomLeftRadius: 0,
                            borderBottomRightRadius: 0,
                            boxShadow: activeTab === "properties" ? "0 2px 6px rgba(3,169,244,0.15)" : "none",
                            "&:hover": {
                                backgroundColor: activeTab === "properties" ? "#e1f5fe" : "#fafafa",
                            },
                        }}
                    >
                        Properties
                    </SoftButton>
                    {isAdmin && (
                        <SoftButton
                        onClick={() => navigate( isAdmin ? `/admin/managers` : isManager ? `/manager/managers` : isStaff ? `/concierge/managers` : isUser ? `/user/managers` : `/unauthorized`)}
                        size="small"
                        sx={{
                            px: 3,
                            ml: 1,
                            borderRadius: "8px",
                            fontWeight: 600,
                            backgroundColor: activeTab === "managers" ? "#e3f2fd" : "#ffffff",
                            color: activeTab === "managers" ? "#03a9f4" : "#9e9e9e",
                            border: "2px solid",
                            borderColor: activeTab === "managers" ? "#b3e5fc" : "#e0e0e0",
                            borderBottom: "none",
                            borderBottomLeftRadius: 0,
                            borderBottomRightRadius: 0,
                            boxShadow: activeTab === "managers" ? "0 2px 6px rgba(3,169,244,0.15)" : "none",
                            "&:hover": {
                                backgroundColor: activeTab === "managers" ? "#e1f5fe" : "#fafafa",
                            },
                        }}
                    >
                        Managers
                    </SoftButton>)}
                    
                    <SoftButton
                        onClick={() => navigate( isAdmin ? `/admin/concierge` : isManager ? `/manager/concierge` : isStaff ? `/concierge/concierge` : isUser ? `/user/concierge` : `/unauthorized`)}
                        size="small"
                        sx={{
                            px: 3,
                            ml: 1,
                            borderRadius: "8px",
                            fontWeight: 600,
                            backgroundColor: activeTab === "concierge" ? "#e3f2fd" : "#ffffff",
                            color: activeTab === "concierge" ? "#03a9f4" : "#9e9e9e",
                            border: "2px solid",
                            borderColor: activeTab === "concierge" ? "#b3e5fc" : "#e0e0e0",
                            borderBottom: "none",
                            borderBottomLeftRadius: 0,
                            borderBottomRightRadius: 0,
                            boxShadow: activeTab === "concierge"
                                ? "0 2px 6px rgba(3,169,244,0.15)"
                                : "none",
                            "&:hover": {
                                backgroundColor:
                                    activeTab === "concierge" ? "#e1f5fe" : "#fafafa",
                            },
                        }}
                    >
                        Concierge
                    </SoftButton>

                </Card>
                {/* Tab Content */}
                {activeTab === "properties" && <AdminProperties />}
                {activeTab === "managers" && <AdminManagers />}
                {activeTab === "concierge" && <AdminConcierge />}
                <Footer />
            </DashboardLayout>
        )
    }

    export default AdminPropertiesDetail